import React from 'react';
import TodoContain from '../../Componant/Todo';

const TodoApp = () => {
  return (
    <div className='page-body'>
      <TodoContain />
    </div>
  );
};

export default TodoApp;
